/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { publicCefrChallengeSampleSchema } from './public-cefr-challenge-sample-schema';
import { publicCefrV1DataSchema } from './public-cefr-v1-data-schema';

export const getPublicCefrV1ResponseSchema = createApiResponseSchema(
  publicCefrV1DataSchema,
) as z.ZodSchema<IAPI<z.infer<typeof publicCefrV1DataSchema>>>;

export type IPublicCefrV1Data = z.infer<typeof publicCefrV1DataSchema>;
export type IPublicCefrChallengeSample = z.infer<typeof publicCefrChallengeSampleSchema>;
export type IGetPublicCefrV1Response = IAPI<IPublicCefrV1Data>;
